(function () {
  const roots = document.querySelectorAll('[data-hok-bulk-order]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const toggle = root.querySelector('[data-hok-bulk-order-toggle]');
    const panel = root.querySelector('[data-hok-bulk-order-panel]');
    const form = root.querySelector('[data-hok-bulk-order-form]');
    const message = root.querySelector('[data-hok-bulk-order-message]');
    const submitUrl = root.dataset.submitUrl || 'https://shopify.dand3.com/hok/bulk-order/submit';
    const productInfo = root.closest('product-info');
    let variantObserver = null;

    function selectedVariant() {
      const node = productInfo?.querySelector('[data-selected-variant]');
      if (!node?.textContent) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (_error) {
        return null;
      }
    }

    function syncFromProductPage() {
      const variant = selectedVariant();
      const variantInput = root.querySelector('[data-hok-bulk-order-variant-id]');
      const versionInput = root.querySelector('[data-hok-bulk-order-version]');
      const itemInput = root.querySelector('[data-hok-bulk-order-item-name]');
      const quantityInput = root.querySelector('[data-hok-bulk-order-quantity]');
      const pageQuantity = productInfo?.querySelector('.quantity__input');

      if (itemInput && root.dataset.productTitle) {
        itemInput.value = root.dataset.productTitle;
      }
      if (variant && variantInput) {
        variantInput.value = String(variant.id || '');
      }
      if (variant && versionInput) {
        versionInput.value = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      }
      if (quantityInput && pageQuantity && !quantityInput.value) {
        quantityInput.value = pageQuantity.value || '1';
      }
    }

    function watchVariantChanges() {
      const node = productInfo?.querySelector('[data-selected-variant]');
      if (!node || variantObserver) return;
      variantObserver = new MutationObserver(syncFromProductPage);
      variantObserver.observe(node, { childList: true, characterData: true, subtree: true });
    }

    function stopWatchingVariantChanges() {
      variantObserver?.disconnect();
      variantObserver = null;
    }

    function setOpen(open) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open) {
        syncFromProductPage();
        watchVariantChanges();
        panel.querySelector('input:not([type="hidden"])')?.focus();
      } else {
        stopWatchingVariantChanges();
      }
    }

    async function submitBulkOrder(event) {
      event.preventDefault();
      if (!form) return;
      const button = form.querySelector('[data-hok-bulk-order-submit]');
      const data = Object.fromEntries(new FormData(form).entries());
      data.sourceUrl = window.location.href;
      if (message) message.hidden = true;
      if (button) button.disabled = true;

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(data),
        });
        const payload = await response.json();
        const ok = Boolean(payload.ok);
        if (message) {
          message.textContent =
            payload.message ||
            (ok
              ? 'Thanks! We received your bulk order request.'
              : payload.errors?.join(' ') || 'Something went wrong. Please try again.');
          message.dataset.status = payload.status || (ok ? 'submitted' : 'failed');
          message.hidden = false;
        }
        if (ok) {
          form.reset();
          syncFromProductPage();
        }
      } catch (_error) {
        if (message) {
          message.textContent = 'Something went wrong. Please try again.';
          message.dataset.status = 'failed';
          message.hidden = false;
        }
      } finally {
        if (button) button.disabled = false;
      }
    }

    toggle?.addEventListener('click', () => {
      setOpen(panel?.hidden !== false);
    });

    form?.addEventListener('submit', submitBulkOrder);
    syncFromProductPage();
  });
})();
